module.exports = __webpack_public_path__ + "img/Pic_Bottom_Pic2.4acfa52e.png";